import axiosMain from 'axios';

export const axios = axiosMain.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

export const axiosAmbient = axiosMain.create({
  baseURL: import.meta.env.VITE_AMBIENT_API_BASE_URL,
});

export const axiosAdmin = axiosMain.create({
  baseURL: import.meta.env.VITE_ADMIN_API_BASE_URL,
});

export const axiosIntegrations = axiosMain.create({
  baseURL: import.meta.env.VITE_INTEGRATIONS_API_BASE_URL,
});

export const axiosAiva = axiosMain.create({
  baseURL: import.meta.env.VITE_PHONE_TRIAGE_API_BASE_URL,
});
